<template>
  <v-app>

			<router-view></router-view>

			<!-- Mensajes: -->
			<v-snackbar
				v-model="$root.mensaje.activo"
				:color="$root.mensaje.color"
				timeout="20000"
			>
				{{ $root.mensaje.descripción }}
				<v-btn
					text
					@click="$root.mensaje.activo = false"
				>
					Cerrar
				</v-btn>
			</v-snackbar>
			<!-- Fin de mensajes -->

  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>
